import axios from "axios";
import html2canvas from "html2canvas";
import { formatDate } from "./DateUtils";
import { createGuid } from "./StringUtils";

const MAX_FILE_SIZE = 1024 * 1024 * 300;

export function eleImageSave(ele:any){
    html2canvas(ele).then((canvas)=>{
        const imgData = canvas.toDataURL('image/png');

        const link = document.createElement("a")
        link.download = formatDate('D') + ".png";
        link.href = imgData;
        document.body.appendChild(link);
        link.click();
        link.remove();
    })
}

export function elePrint(ele:any){
    html2canvas(ele).then((canvas)=>{
        const printWin:any = window.open('');
        printWin.document.body.appendChild(canvas);
        printWin.focus();
        printWin.print();
        printWin.close();
    })
}
export function uploadFile(callback:Function) {
	
    const fileUploadInput = document.querySelector('#file_upload_input');
    if(fileUploadInput){
        fileUploadInput.remove();
    }

    const fileEle = document.createElement('input');

    fileEle.type = "file";
    fileEle.classList.add('hide');
    fileEle.accept = '.doc,.hwp,.pdf,.txt,.xls,.ppt,.zip,.alz,.rar,.bmp,.gif,.jpeg,.jpg,.png';
    fileEle.multiple = true;
    fileEle.onchange = async function(){
        if(fileEle['files']){

            let callBackFileList:any = [];

            const fileList:any = fileEle['files'];

            // 개수체크
            if(fileList.length > 5){
                alert("파일은 최대 5개까지 첨부 가능합니다.");
                return;
            }

            // 용량체크
            let totalFileSize = 0;
            for(let i=0; i<fileList.length; i++) {
                const file = fileList[i];
                totalFileSize += file.size;
            }

            if(totalFileSize > MAX_FILE_SIZE){
                alert("업로드 최대용량은" + MAX_FILE_SIZE/1024/1024 +'M 입니다.');
                return;
            }

            for(let i=0; i<fileList.length; i++) {
                const fileName = formatDate('yyyyMMddHHmmss') + createGuid();

                const file = fileList[i];
                const realFileName = file['name'];

                const form = new FormData();
                form.append(fileName , file);

                const fileAccept = realFileName.substring(realFileName.lastIndexOf('.')).toLowerCase();
                let flag = false;
                fileEle.accept.split(',').forEach(function(item:string){
                    if(item.toLowerCase() == fileAccept){
                        flag = true;
                    }	
                });

                if(flag == false){
                    alert(fileAccept + " 지원하지않는 포맷입니다.");
                    return;
                }
    
                if(file.size == 0){
                    alert("업로드 파일사이즈가 0바이트입니다.");
                    return;
                }
                
                if(file.size > MAX_FILE_SIZE){
                    alert("업로드 최대용량은" + MAX_FILE_SIZE/1024/1024 +'M 입니다.');
                    return;
                }
    
                const res = await axios.post("/serviceEndpoint/fileUpload", form);

                callBackFileList.push({"fileName" : fileName, "realFileName" : realFileName});
            }
                        
            callback && callback(callBackFileList);
        }
    }


    fileEle.click();
}


export function downloadFile(filePath: string, fileName:string) {
    const url = '/serviceEndpoint/fileDownload?filePath=' + encodeURIComponent(filePath) +"&fileName=" + encodeURIComponent(fileName);
    const aEle = document.createElement("a");
    aEle.href = url;
    document.body.appendChild(aEle);
    aEle.click();
    aEle.remove();

    setTimeout(function () { URL.revokeObjectURL(url); }, 100); // cleanup
}